var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464 464",
    style: {
      enableBackground: "new 0 0 464 464"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82C8DC"
    },
    points: "0,156 232,428 128.889,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B4E6F0"
    },
    points: "335.111,156 232,428 464,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9FFFF"
    },
    points: "232,156 335.111,156 232,36 128.889,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A0DCE6"
    },
    points: "232,156 128.889,156 232,428 335.111,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A0DCE6"
    },
    points: "104,36 0,156 128.889,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBFFFF"
    },
    points: "464,156 360,36 335.111,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B4E6F0"
    },
    points: "360,36 232,36 335.111,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B4E6F0"
    },
    points: "232,36 104,36 128.889,156  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.07fe8c505c2d1b6820affb0bcbe0acf5.svg";
export { ForwardRef as ReactComponent };